// What a cost or settlement detail (its drawer, the settlement page) shows
// while the record its link names is not there. rentio-api-next answers 404
// for a record the viewer may not read (another owner's unit, a draft an
// owner may not change, a deleted one) and 403 when access is refused
// outright: both read as "gone or not yours", where a spinner waited forever
// (X05). Any other failure may pass, so it offers to try again.

const HTTP_FORBIDDEN = 403;
const HTTP_NOT_FOUND = 404;

export type TMissingDetailState = "loading" | "unavailable" | "load_failed";

interface IRequestError {
  status?: number;
  statusCode?: number;
  response?: { status?: number };
}

const statusOf = (error: unknown): number | undefined => {
  const requestError = (error ?? {}) as IRequestError;
  return (
    requestError.response?.status ??
    requestError.status ??
    requestError.statusCode
  );
};

// Nothing loaded and nothing failed is still loading: also the very first
// render, before the fetch is even dispatched.
export const getMissingDetailState = (params: {
  isFetching: boolean;
  fetchError?: unknown;
}): TMissingDetailState => {
  const { isFetching, fetchError } = params;
  if (isFetching || !fetchError) return "loading";

  const status = statusOf(fetchError);
  return status === HTTP_NOT_FOUND || status === HTTP_FORBIDDEN
    ? "unavailable"
    : "load_failed";
};
